import React from 'react';

type ImageSource = {
  url: string;
  id: string;
  loading: boolean;
};

export default function useListImageLoader(
  image: ImageSource,
  setSrc: React.Dispatch<React.SetStateAction<ImageSource>>,
  matches: boolean = false,
) {
  //! fix bug, render every where
  React.useEffect(() => {
    if (matches) return;

    const controller = new AbortController();
    const signal = controller.signal;

    const loadImage = async () => {
      try {
        const response = await fetch(image?.url, { signal });

        const blob = await response.blob();
        const imageUrl = URL.createObjectURL(blob);

        const img = new Image();
        img.onload = () => {
          setSrc((prevState) => ({
            ...prevState,
            id: image?.id,
            loading: false,
          }));
        };

        setSrc((prevState) => ({
          ...prevState,
          id: image?.id,
          url: imageUrl,
        }));

        img.src = imageUrl;
      } catch (error) {
        console.log(error);
      }
    };

    loadImage();

    return () => {
      controller.abort();
    };
  }, [image, matches]);
}
